import ProfilePanel from "./profilePanel.container";

export default ProfilePanel;
